import { vars } from '@repo/config';
import type { ISessionApiResponse } from '../types/i-session-api-response';
import type { IUserSession } from '../types/i-user-session';
import { createGetFetchOptions } from './helper';

export async function getSessionServer(cookieHeader: string): Promise<IUserSession | null> {
  try {
    const sessionUrl = new URL('/api/auth/get-session', vars.url.identityUrl);
    const response = await fetch(sessionUrl.toString(), createGetFetchOptions({ cookieHeader }));

    if (!response.ok) {
      return null;
    }

    const data = (await response.json()) as ISessionApiResponse;

    if (!data.user) {
      return null;
    }

    return {
      ...(data.session || {}),
      user: data.user,
    };
  } catch {
    return null;
  }
}
